export default () => {
  const root = document.documentElement;
  const header = document.getElementById('header');
  const currentLocation = window.location;

  const safeQuerySelector = (selector) => {
    try {
      return document.querySelector(selector);
    } catch (error) {
      return null;
    }
  };

  const getRootScrollOffset = () => {
    const rootStyles = window.getComputedStyle(root);
    const offsetValue = rootStyles.getPropertyValue('--smooth-scroll-offset-gap');
    return Number.parseFloat(offsetValue) || 0;
  };

  const getHeaderScrollOffset = () => {
    if (!header) {
      return 0;
    }

    const headerStyles = window.getComputedStyle(header);
    const isFixedHeader = headerStyles.position === 'fixed' || headerStyles.position === 'sticky';

    return isFixedHeader ? header.getBoundingClientRect().height : 0;
  };

  const getTargetScrollOffset = (targetElement) => {
    const targetStyles = window.getComputedStyle(targetElement);
    const targetScrollMarginTop = Number.parseFloat(targetStyles.scrollMarginTop) || 0;
    const sharedOffset = getHeaderScrollOffset() + getRootScrollOffset();

    return Math.max(targetScrollMarginTop, sharedOffset);
  };

  const scrollToTarget = (targetElement) => {
    const scrollOffset = getTargetScrollOffset(targetElement);
    const rect = targetElement.getBoundingClientRect();
    const absoluteTop = window.scrollY + rect.top - scrollOffset;

    if (Math.abs(window.scrollY - absoluteTop) > 1) {
      window.scrollTo({
        top: absoluteTop,
        behavior: 'smooth',
      });
    }
  };

  const normalizePathname = (pathname) => {
    const normalizedPath = pathname.replace(/\/index\.html$/, '/');
    const trimmedPath = normalizedPath.replace(/\/+$/, '');

    return trimmedPath || '/';
  };

  const resolveSamePageHash = (href) => {
    if (!href) {
      return null;
    }

    let resolvedUrl;

    try {
      resolvedUrl = new URL(href, currentLocation.href);
    } catch (error) {
      return null;
    }

    if (!resolvedUrl.hash || resolvedUrl.hash === '#') {
      return null;
    }

    const isSameOrigin = resolvedUrl.origin === currentLocation.origin;
    const isSamePath = normalizePathname(resolvedUrl.pathname) === normalizePathname(currentLocation.pathname);
    const isSameSearch = resolvedUrl.search === currentLocation.search;

    if (!isSameOrigin || !isSamePath || !isSameSearch) {
      return null;
    }

    return resolvedUrl;
  };

  const scrollToHash = (hash) => {
    if (hash && hash !== '#') {
      const targetElement = safeQuerySelector(hash);
      if (targetElement) {
        setTimeout(() => scrollToTarget(targetElement), 0);
      }
    }
  };

  window.addEventListener('load', () => {
    scrollToHash(window.location.hash);
  });

  window.addEventListener('hashchange', () => {
    scrollToHash(window.location.hash);
  });

  document.querySelectorAll('a[href*="#"]').forEach(anchor => {
    anchor.addEventListener('click', (event) => {
      const href = anchor.getAttribute('href');
      const resolvedUrl = resolveSamePageHash(href);

      if (!href || href === '#') {
        event.preventDefault();
        return;
      }

      if (!resolvedUrl) {
        return;
      }

      const targetElement = safeQuerySelector(resolvedUrl.hash);

      if (targetElement) {
        event.preventDefault();
        scrollToTarget(targetElement);

        if (window.location.hash !== resolvedUrl.hash) {
          history.pushState(null, '', `${window.location.pathname}${window.location.search}${resolvedUrl.hash}`);
        }
      } else {
        event.preventDefault();
        console.error(`No target found for smooth scroll: ${resolvedUrl.hash}`);
      }
    });
  });
};
